import classnames from 'classnames';
import { format, getWeek } from 'date-fns';
import deLocale from 'date-fns/locale/de';
import React from 'react';
import { DateOverviewCalendar } from "./components/DateOverviewCalendar.js";
import styles from "./DateOverview.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DateOverview = ({
  date = new Date(),
  className
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.dateOverview, className),
    children: [/*#__PURE__*/_jsx("p", {
      className: styles.date,
      children: format(date, 'dd.MM.')
    }), /*#__PURE__*/_jsxs("p", {
      className: styles.calendarWeek,
      children: ["KW ", getWeek(date, {
        locale: deLocale
      })]
    }), /*#__PURE__*/_jsx(DateOverviewCalendar, {
      date: date
    })]
  });
};